/* import __COLOCATED_TEMPLATE__ from './pagination-controls.hbs'; */
var _dec, _dec2, _dec3, _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { action, computed, set } from '@ember/object';
import { NEXT_PAGE_SIZE } from '@banking/api/services/banking-unit-account-pagination';
let PaginationControls = (_dec = computed('units.length'), _dec2 = computed('currentPage', 'numberOfPages', 'bankingUnitAccountPagination.isLoading'), _dec3 = computed('currentPage', 'numberOfPages'), (_class = class PaginationControls extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "bankingUnitAccountPagination", _descriptor, this);
    _defineProperty(this, "units", void 0);
    _defineProperty(this, "balances", void 0);
    _defineProperty(this, "pageStart", void 0);
    _defineProperty(this, "pageEnd", void 0);
    _defineProperty(this, "currentPage", 1);
  }
  get numberOfPages() {
    return Math.ceil(this.units?.length / NEXT_PAGE_SIZE);
  }

  // Do not allow them to spam click right while loading, otherwise it will send multiple requests
  get canGoRight() {
    return this.currentPage < this.numberOfPages && !this.bankingUnitAccountPagination.isLoading;
  }
  get canGoLeft() {
    return this.currentPage > 1;
  }
  async goRight() {
    if (!this.canGoRight) {
      return;
    }
    set(this, 'currentPage', this.currentPage + 1);
    const nextPageStart = (this.currentPage - 1) * NEXT_PAGE_SIZE;
    set(this, 'pageStart', nextPageStart);
    set(this, 'pageEnd', nextPageStart + NEXT_PAGE_SIZE);

    // If we are trying to view balances that are currently not loaded, load them
    if (this.pageStart > this.balances.length - 1) {
      await this.bankingUnitAccountPagination.getNextPage();
    }
  }
  goLeft() {
    if (!this.canGoLeft) {
      return;
    }
    set(this, 'currentPage', this.currentPage - 1);
    const previousPageStart = (this.currentPage - 1) * NEXT_PAGE_SIZE;
    set(this, 'pageStart', previousPageStart);
    set(this, 'pageEnd', previousPageStart + NEXT_PAGE_SIZE);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "bankingUnitAccountPagination", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "numberOfPages", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "numberOfPages"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canGoRight", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "canGoRight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canGoLeft", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "canGoLeft"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goRight", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goRight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goLeft", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goLeft"), _class.prototype)), _class));
export { PaginationControls as default };